/**
 * Main Entry Point
 * Water Management System
 * 
 * This file:
 * 1. Sets up Redux Provider for state management
 * 2. Renders the root App component
 * 3. Imports global styles
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './app';
import { store } from './store';
import './styles/index.css';

// Ensure root element exists
const root_element = document.getElementById('root');

if (!root_element) {
  throw new Error('Failed to find the root element');
}

ReactDOM.createRoot(root_element).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);